// adding some validations logic for awards form
import { required, url, minLength, maxLength } from 'vuelidate/lib/validators'

export const FORM_AWARDS_VALIDATIONS = {
  dataForm: {
    awardLink: {
      required,
      url
    },
    awardName: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(100)
    },
    awardDateIssued: {
      required
    },
    awardIssuingOrgName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    awardIssuingOrgLink: {
      url
    },
    awardDescription: {
      minLength: minLength(25),
      maxLength: maxLength(255)
    },
    awardSrc: {
      required,
    },
    awardType: {
      required
    },
  }
};



// WEBPACK FOOTER //
// ./src/validations/formAwards.js